import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { ConvertorMiladi } from 'utilities/helper/digitToMonth'
interface IItemProps {
    item: IFinancialLoan
    name: string
}
export default function Item({ item, name }: IItemProps) {
    const navigate = useNavigate()
    const { moneyPool, poolship } = useParams()
    return (
        <div
            className="bg-main-bg px-2 py-1 items-center my-2 mx-2 rounded-md"
            onClick={() =>
                navigate(
                    `/fund/financial-history/funds-detail/${moneyPool}/${poolship}/${item.id}`,
                    {
                        state: { name },
                    }
                )
            }
        >
            <div className=" flex justify-between items-center ">
                <p>{item.poolship_name}</p>
                {item.is_fully_repaid ? (
                    <p className=" text-sm bg-white px-1 py-1 rounded-md">
                        تسویه شده
                    </p>
                ) : (
                    <p className=" text-sm">{item.number_of_repayments} قسط</p>
                )}
                <div className=" text-sm text-left">
                    <p>{item.amount && item.amount.toLocaleString()} تومان</p>
                    <p>{item?.pay_date && ConvertorMiladi(item.pay_date)}</p>
                </div>
            </div>
            {item.tag && item.tag.length > 0 && (
                <div className=" mt-2">
                    <hr />
                    <p className=" text-sm">توضیحات: {item.tag}</p>
                </div>
            )}
        </div>
    )
}
